import * as React from "react";
export const FilterUpIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={14} height={18} viewBox="0 0 14 18" {...props}>
      <path
        fill="#6d7278"
        d="M7 2.93L1.43 8.5L-0.07 7L7 -0.07L14.07 7L12.57 8.5L7 2.93Z"
      />
      <path fill="#6d7278" d="M8 2L8 18L6 18L6 2L8 2Z" />
    </svg>
  );
};
